export default __webpack_public_path__ + "static/media/switch_on.e16a0607.png";